<ng-template #overviewRow [appLinkedItemTableOverview]="itemKey" let-item>
    @if (item.confidential) {
        <!-- The table does not expand an element marked data-linked-item-table-action, so a click explains why instead. -->
        <td data-linked-item-table-action (click)="confidentialRowClick.emit(item)">
            <span class="item-name">{{ item.name }}</span>
            @if (item.identifier) {
                <span class="item-reference">{{ 'identifier' | t: { identifier: item.identifier } }}</span>
            }
        </td>
        <td colspan="2" data-linked-item-table-action data-uiid="linked-risk-confidential" (click)="confidentialRowClick.emit(item)">
            <span class="item-reference">{{ confidentialLabel }}</span>
        </td>
    } @else {
        <td>
            <span class="item-name">{{ item.name }}</span>
            @if (item.identifier) {
                <span class="item-reference">{{ 'identifier' | t: { identifier: item.identifier } }}</span>
            }
        </td>
        <td><app-cerrix-color-box-label [label]="item.grossRisk" [color]="item.grossRiskColor" /></td>
        <td><app-cerrix-color-box-label [label]="item.netRisk" [color]="item.netRiskColor" /></td>
    }
</ng-template>
<ng-template #detailRow [appLinkedItemTableDetail]="detailContext" let-item let-details="details">
    <div class="detail-content">
        <dl><dt>{{ 'details.owner' | t }}</dt><dd class="person">
            <app-cerrix-avatar [name]="details.owner" />
            {{ details.owner }}
        </dd></dl>
        <strong>{{ 'details.description' | t }}</strong>
        <p>{{ details.description }}</p>
    </div>
</ng-template>
